const FacebookPixel = () => events => {
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window.fbq !== 'function') {
    // throw new Error(
    //   'window.fbq is not defined, have you forgotten to include Facebook Pixel?'
    // );
    console.error('window.fbq is not defined, have you forgotten to include Facebook Pixel?')
    return;
  }
  events.forEach(event => {
    const {
      content_name,
      content_type,
      content_category,
      content_ids,
      value,
      currency,
      search_string
    } = event

    switch (event.type) {
      case 'viewcontent':
        window.fbq('track', 'ViewContent', {
          content_name,
          content_type,
          content_ids,
          value,
          currency
        })
        break
      case 'lead':
        window.fbq('track', 'Lead', {
          content_name,
          content_category,
          value,
          currency
        })
        break
      case 'completeregistration':
        window.fbq('track', 'CompleteRegistration')
        break
      case 'search':
        window.fbq('track', 'Search', {
          search_string
        })
        break
      default:
        break
    }
  })
}

export default FacebookPixel



// WEBPACK FOOTER //
// ./src/tracking/facebook-pixel/facebook-pixel.js